import { useQuery } from "react-query";
import { getExhibitors } from "../../services/scientific/exhibitor";
import { PagedRequestType } from "../../types/PagedResults";
import { EXHIBITORS, Key_exhibitors } from "../../utils/constants";

export const useGetExhibitorsQuery = (data: PagedRequestType) =>
  useQuery(
    [Key_exhibitors, JSON.stringify(data)],
    () => getExhibitors(data)
  );
